import { render, staticRenderFns } from "./mnav.vue?vue&type=template&id=b015402a"
import script from "./mnav.vue?vue&type=script&lang=js"
export * from "./mnav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports